import Link from '@mui/material/Link';
import NextLink from 'atoms/NextLink';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import TickerList from 'molecules/TickerList';
import React from 'react';
import { formatAmount } from 'stores/financeUtils';
import { IOrder, OrderType } from 'stores/networkInterfaces';
import { roundToOne, toPremiumFormat } from 'utils/math';
import { getOfferingUrl } from 'utils/navigateUtils';
import { calculatePremium } from 'utils/orderUtils';

import s from './OrdersList.module.scss';

interface OrdersListProps {
  orders?: Array<IOrder>;
  className?: string;
}

const OrdersList = ({ orders, className }: OrdersListProps) => {
  if (isEmpty(orders)) {
    return null;
  }

  const items = orders
    ?.filter((order) => order?.offering_id && order?.offering_name && order?.total)
    ?.map((order, i) => (
      <span key={`order-${i}`}>
        <NextLink passHref href={getOfferingUrl(order?.offering_id) ?? ''}>
          <Link color="inherit" underline="none">
            <div className={s.OrdersList__item}>
              <div className={cn(s.OrdersList__line, s.OrdersList__header)}>
                {order?.order_type == OrderType.bid_sell ? 'Sell order' : 'Buy order'}
              </div>
              <div className={s.OrdersList__line}>
                <div className={s.OrdersList__title}>
                  <span className={s.OrdersList__symbol}>{order.offering_id}</span>
                  <span className={s.OrdersList__name}>{order.offering_name}</span>
                </div>
              </div>
              <div className={s.OrdersList__line}>
                <div className={s.OrdersList__line}>
                  <span className={s.OrdersList__total}>
                    {formatAmount(order?.total, order?.currency, 0)}
                  </span>
                  <span className={s.OrdersList__premium}>
                    (
                    {toPremiumFormat({
                      value: calculatePremium(order?.offering_price, order?.price),
                      callback: roundToOne
                    })}
                    )
                  </span>
                </div>
              </div>
            </div>
          </Link>
        </NextLink>
      </span>
    ));

  return <TickerList className={className} items={items} />;
};

export default OrdersList;
